'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './detail.routes';


export class DetailComponent {
  /*@ngInject*/
  constructor(lookup,$scope,$state,$anchorScroll,$http, mapService) {
    this.$scope = $scope;
    this.lookup = lookup;
    this.mapService = mapService;
    this.$state = $state;
    this.$anchorScroll = $anchorScroll;
    this.$scope = $scope;
    this.$http = $http;
  }

  $onInit(){
    
    this.$anchorScroll();
    this.$scope.mapLayers = this.mapService.getMapLayers();
    // console.log(this.$scope.mapLayers);

    function initTheme() {
      var transparent = true;
      var big_image;

      var transparentDemo = true;
      var fixedTop = false;

      var navbar_initialized,
        backgroundOrange = false,
        toggle_initialized = false;

      var nowuiKit,
        $navbar,
        $toggle,
        scroll_distance,
        oVal;

      $(document).ready(function () {
        //  Activate the Tooltips
        $('[data-bs-toggle="tooltip"], [rel="tooltip"]').tooltip();

        //    Activate bootstrap-select
        if ($(".selectpicker").length != 0) {
          $(".selectpicker").selectpicker({
            iconBase: "now-ui-icons",
            tickIcon: "ui-1_check"
          });
        };

        if ($(window).width() >= 768) {
          big_image = $('.header[data-parallax="true"]');
          if (big_image.length != 0) {
            $(window).on('scroll', nowuiKit.checkScrollForParallax);
          }
        }

        // Activate Popovers and set color for popovers
        $('[data-bs-toggle="popover"]').each(function () {
          color_class = $(this).data('color');
          $(this).popover({
            template: '<div class="popover popover-' + color_class + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
          });
        });

        //Activate tags
        // we style the badges with our colors
        var tagClass = $('.tagsinput').data('color');

        if ($(".tagsinput").length != 0) {
          $('.tagsinput').tagsinput();
        }

        $('.bootstrap-tagsinput').addClass('text-bg-' + tagClass + '');

        // Activate the image for the navbar-collapse
        nowuiKit.initNavbarImage();

        // Adding class show on the navbar-collapse for animation working properly
        $('.navbar-collapse').addClass('show');

        $navbar = $('.navbar[color-on-scroll]');
        scroll_distance = 50;
        // scroll_distance = $navbar.attr('color-on-scroll') || 500;

        // Check if we have the class "navbar-color-on-scroll" then add the function to remove the class "navbar-transparent" so it will transform to a plain color.
        if ($('.navbar[color-on-scroll]').length != 0) {
          nowuiKit.checkScrollForTransparentNavbar();
          $(window).on('scroll', nowuiKit.checkScrollForTransparentNavbar)
        }

        $('.form-control').on("focus", function () {
          $(this).parent('.input-group').addClass("input-group-focus");
        }).on("blur", function () {
          $(this).parent(".input-group").removeClass("input-group-focus");
        });

        // Activate bootstrapSwitch
        $('.bootstrap-switch').each(function () {
          $this = $(this);
          data_on_label = $this.data('on-label') || '';
          data_off_label = $this.data('off-label') || '';

          $this.bootstrapSwitch({
            onText: data_on_label,
            offText: data_off_label
          });
        });

        if ($(window).width() >= 992) {
          big_image = $('.page-header-image[data-parallax="true"]');

          $(window).on('scroll', nowuiKit.checkScrollForParallax);
        }


      });

      $(window).on('resize', function () {
        nowuiKit.initNavbarImage();
      });

      $(document).on('click', '.navbar-toggler', function () {
        var $toggle, div;
        $toggle = $(this);
        console.log('should be toggling');
        if (nowuiKit.misc.navbar_menu_visible == 1) {
          $('html').removeClass('nav-open');
          nowuiKit.misc.navbar_menu_visible = 0;
          $('#bodyClick').remove();
          setTimeout(function () {
            $toggle.removeClass('toggled');
          }, 550);
        } else {
          setTimeout(function () {
            $toggle.addClass('toggled');
          }, 580);
          div = '<div id="bodyClick"></div>';
          $(div).appendTo('body').click(function () {
            $('html').removeClass('nav-open');
            nowuiKit.misc.navbar_menu_visible = 0;
            setTimeout(function () {
              $toggle.removeClass('toggled');
              $('#bodyClick').remove();
            }, 550);
          });

          $('html').addClass('nav-open');
          nowuiKit.misc.navbar_menu_visible = 1;
        }
      });


      nowuiKit = {
        misc: {
          navbar_menu_visible: 0
        },

        checkScrollForTransparentNavbar: debounce(function () {
          if ($(document).scrollTop() > scroll_distance) {
            if (transparent) {
              transparent = false;
              $('.navbar[color-on-scroll]').removeClass('navbar-transparent');
            }
          } else {
            if (!transparent) {
              transparent = true;
              $('.navbar[color-on-scroll]').addClass('navbar-transparent');
            }
          }
        }, 17),

        initNavbarImage: function () {
          var $navbar = $('.navbar').find('.navbar-translate').siblings('.navbar-collapse');
          var background_image = $navbar.data('nav-image');

          if (background_image != undefined) {
            if ($(window).width() < 991 || $('body').hasClass('burger-menu')) {
              $navbar.css('background', "url('" + background_image + "')")
                .removeAttr('data-nav-image')
                .css('background-size', "cover")
                .addClass('has-image');
            } else {
              $navbar.css('background', "")
                .attr('data-nav-image', '' + background_image + '')
                .css('background-size', "")
                .removeClass('has-image');
            }
          }
        },


      }

      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.

      function debounce(func, wait, immediate) {
        var timeout;
        return function () {
          var context = this,
            args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
          }, wait);
          if (immediate && !timeout) func.apply(context, args);
        };
      };
    }

    initTheme();
    // console.log(this.lookup.getDataDetail().keys);
    if(!_.isEmpty(this.lookup.getDataDetail())){
      this.$scope.dataDetail = this.lookup.getDataDetail();
      console.log(this.$scope.dataDetail);
      $('#dataset-description').html(this.$scope.dataDetail.source_dataset_description);
    } else {
      this.$state.go('sources');
    }

    // this.loadMap();
    
  }

  loadMap(){
  var map;
  var mapLayers = this.$scope.mapLayers;
  var dataDetail = this.$scope.dataDetail;
  var $http = this.$http;
  var $scope = this.$scope;
      //Load Map
      mapboxgl.accessToken = 'pk.eyJ1IjoiY2hhcmxpZWRvdGF1IiwiYSI6ImNpazlpdzh0ZTA5d3Z2Y200emhqbml1OGEifQ.uoA6t5rO18m0BgNGPXsm5A';
      map = new mapboxgl.Map({
        container: 'map-data',
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        zoom: 8,
        center: [-122.275051, 37.796966] //Set center based on geojson feature
      });

      // Add zoom and rotation controls to the map.
      map.addControl(new mapboxgl.NavigationControl());

      map.on('load', function () {
       
        // console.log(dataDetail.dataset_name);
        var addLayer = _.filter(mapLayers,{'full_name':dataDetail.dataset_name});
        console.log(addLayer);
       
        $http.get(addLayer[0].url)
                .then(response => {
                  var layerData = response.data;
                  console.log(layerData);
                  map.addSource(addLayer[0].source, {
                    "type": layerData.sources.composite.type,
                    "url": layerData.sources.composite.url //Parcel Atlas (updated December 9 2020)
                  });
        
                  map.addLayer({
                    "id": addLayer[0].name,
                    "type": layerData.layers[0].type,
                    "source": addLayer[0].source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    "paint": layerData.layers[0].paint
                  });
                  map.setLayoutProperty(addLayer[0].name, 'visibility', 'visible');
                  $scope.loadingDiv = false;
                })
                .catch(err => {
                  console.log(err);
                })

        // When a click event occurs on a feature in the states layer, open a popup at the
        // location of the click, with description HTML from its properties.
        map.on('click', 'parcels', function (e) {

          // set bbox as 5px reactangle area around clicked point
          // var bbox = [
          //     [e.point.x - 5, e.point.y - 5],
          //     [e.point.x + 5, e.point.y + 5]
          // ];
          // var features = map.queryRenderedFeatures(bbox, {
          //     layers: ['parcels']
          // });

          // console.log(features[0].properties);
          updateInfoBox(e.features[0].properties.parcel_id, $http, $scope);

          new mapboxgl.Popup()
            .setLngLat(e.lngLat)
            .setHTML(e.features[0].properties.parcel_id)
            .addTo(map);
        });

        // // Change the cursor to a pointer when the mouse is over the states layer.
        // map.on('mouseenter', 'parcels', function() {
        //     map.getCanvas().style.cursor = 'pointer';
        // });

        // // Change it back to a pointer when it leaves.
        // map.on('mouseleave', 'parcels', function() {
        //     map.getCanvas().style.cursor = '';
        // });




      });

      $('#siteSelectionModal').on('shown.bs.modal', function () { // chooseLocation is the id of the modal.
        if (map) {
          map.resize();
        }
      });

      this.$scope.resize = function () {
        console.log('resizing');
        $timeout(function () {
          if (map) {
            map.resize();
          }
        }, 500)

      }
this.$scope.map = map;


    
  }

  
}

export default angular.module('hessPublicApp.detail', [uiRouter])
  .config(routes)
  .component('detail', {
    template: require('./detail.html'),
    controller: DetailComponent,
    controllerAs: 'detailCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/detail/detail.component.js